import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { API_URL } from '@core/config/api-url.token';
import { API_ENDPOINTS } from '@shared/constants/api-endpoints.const';
import { TokenResponseDto } from '@features/shared/auth/data/dtos/auth.dto';
import { Observable } from 'rxjs';
import {
  SetDefaultStaffClinicRequestDto, StaffClinicDto, StaffClinicMembershipAcceptanceDto, SwitchStaffClinicRequestDto,
} from '../../dtos/staff-clinic.dto';

@Injectable({ providedIn: 'root' })
export class StaffClinicsRemoteDatasource {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = inject(API_URL);

  public list(): Observable<StaffClinicDto[]> {
    return this.http.get<StaffClinicDto[]>(`${this.apiUrl}${API_ENDPOINTS.auth.clinics.list}`);
  }

  public switchClinic(clinicId: number, refreshToken: string): Observable<TokenResponseDto> {
    const request: SwitchStaffClinicRequestDto = { OrganizationId: clinicId, RefreshToken: refreshToken };
    return this.http.post<TokenResponseDto>(`${this.apiUrl}${API_ENDPOINTS.auth.clinics.switch}`, request);
  }

  public setDefault(clinicId: number): Observable<void> {
    const request: SetDefaultStaffClinicRequestDto = { OrganizationId: clinicId };
    return this.http.put<void>(`${this.apiUrl}${API_ENDPOINTS.auth.clinics.setDefault}`, request);
  }

  public acceptInvitation(invitationId: string): Observable<StaffClinicMembershipAcceptanceDto> {
    return this.http.post<StaffClinicMembershipAcceptanceDto>(
      `${this.apiUrl}${API_ENDPOINTS.auth.clinics.acceptInvitation(invitationId)}`,
      {},
    );
  }

  public rejectInvitation(invitationId: string): Observable<void> {
    return this.http.post<void>(`${this.apiUrl}${API_ENDPOINTS.auth.clinics.rejectInvitation(invitationId)}`, {});
  }
}
